module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-rooms/quickstart-rooms.component.html
// module id = 1588
// module chunks = 2